module.exports = __webpack_public_path__ + "static/media/Rahul Nanuhal.f992e7eb.png";